import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseTmaisBadgesProps<T> {
  filters?: {
    search?: string
    page?: number
  }
  mapper?: (data: any) => T
}

export const useTmaisBadges = <T,>({
  filters: { search = '', page } = {},
  mapper = Mapper.default<T>(),
}: UseTmaisBadgesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisBadges', search, page],
    queryFn: () =>
          privateAxios.get('/tmais/badges', {
            params: {
              search: search || undefined, 
              page,
            },
          }),
    select: (response: { data: { data: any[]; meta: MetaResponse } }) => ({
      data: mapper(response?.data?.data),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
